import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { catchError, throwError } from 'rxjs';

// TODO: delete and use default Sentry.httpClientIntegration when attaching response body is supported https://github.com/getsentry/sentry-javascript/issues/12544
export const sentryHttpInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      Sentry.captureMessage(
        `HTTP Error ${error.status} ${req.method} ${req.url} ${JSON.stringify(error.error)}`,
        {
          level: error.status >= 500 ? 'error' : 'info',
          extra: {
            method: req.method,
            url: req.url,
            status: error.status,
            statusText: error.statusText,
            responseBody: error.error,
            requestBody: JSON.stringify(req.body),
          },
        },
      );

      return throwError(() => error);
    }),
  );
};
